import { useState } from "react";

export default function useErpItemCountHook() {
    const [orderItemCount, setOrderItemCount] = useState(null);
    const [holdItemCount, setHoldItemCount] = useState(null);

    const onSetOrderItemCount = (value) => {
        setOrderItemCount(value);
    }

    const onSetHoldItemCount = (value) => {
        setHoldItemCount(value);
    }

    return {
        orderItemCount,
        holdItemCount,
        onSetOrderItemCount,
        onSetHoldItemCount
    }
}